export const TOGGLE_PARKING_RESEARCH_FROM_INTRO = 'TOGGLE_PARKING_RESEARCH_FROM_INTRO'

export function displayParkingResearchFromIntroReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_PARKING_RESEARCH_FROM_INTRO:
            return action.payload
        default: return state
    }
}